import React from 'react';
import { Button, Modal, useLastPresent } from '@nsi-advisory-services/components';

// Shown after each expense is saved into a group, so the employee can keep
// filing without going back to the expense page between receipts.
export default function ExpenseGroupNextStepModal({ open, onClose, groupName: liveName, savedCount: liveCount, onAddAnother }) {
  // Held while the dialog fades out: finishing the group clears it on the page.
  const { groupName, savedCount } = useLastPresent(open ? { groupName: liveName, savedCount: liveCount } : null)
    || { groupName: liveName, savedCount: liveCount };
  return (
    <Modal open={open} onClose={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>Saved to group</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>{groupName}</div>
        <div className="text-muted">
          {savedCount} expense{savedCount === 1 ? '' : 's'} saved so far. Nothing is sent for
          approval until you submit the group.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>I'm done</Button>
        <Button variant="primary" icon="plus-lg" onClick={onAddAnother}>
          Add another expense
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
